import {
  DesignTokenSizeEnum,
  Text,
  TokenTextAppearance,
  TokenTextColor,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { useTribalContext } from '@/context/tribal';
import { formatDate } from '@/modules/utils/storeUtils';
import useGlobalStore from '@/stores/globalStore';
import Box from '../../Box/Box';
import CTADownloadBrochure from '../../CTADownloadBrochure/CTADownloadBrochure';
import { StyledFooterWelcome } from './FooterWelcome.styles';
import { SectionNames } from '@/analytics/sectionNames';

const FooterWelcome = () => {
  const { contentManager } = useTribalContext();

  const customerFirstName = useGlobalStore(
    (state) => state.app.message?.parameters?.customerFirstName
  ) as string;

  const date = useGlobalStore((state) => state.app.createdAt) as string;

  const thanksMessage = contentManager.getParsedString('footer-thanks-text', [
    {
      identifier: 'customerFirstName',
      value: customerFirstName,
    },
  ]);

  const dateText = contentManager.getParsedString(
    'footer-brochure-created-date-text',
    [
      {
        identifier: 'date',
        value: formatDate(date),
      },
    ]
  );

  return (
    <StyledFooterWelcome>
      <Text
        tag={TextTag.h3}
        appearance={TokenTextAppearance.bigcopy200}
        color={TokenTextColor.primary}
        bold
      >
        {thanksMessage}
      </Text>
      <Box
        as={Text}
        tag="p"
        mb={DesignTokenSizeEnum.static350}
        appearance={TokenTextAppearance.copy200}
      >
        {contentManager.get('footer-brochure-description')}
      </Box>
      <Box mb={DesignTokenSizeEnum.static250}>
        <CTADownloadBrochure sectionName={SectionNames.FOOTER} />
      </Box>
      {date && <div><Text appearance={TokenTextAppearance.copy200}>{dateText}</Text></div>}
    </StyledFooterWelcome>
  );
};

export default FooterWelcome;
